import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LayoutGrid, Eye, EyeOff } from "lucide-react";

const Headers = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            {/* <img
              src="/logo.svg"
              alt="AssessPro Logo"
              className="h-8 w-auto mr-2"
            /> */}
             <LayoutGrid className="h-8 w-8 text-primary" />
            <span className="font-bold text-xl">AssessPro</span>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          <Link
            to="/"
            className={`transition-colors ${
              isActive("/") ? "text-primary font-semibold" : "hover:text-primary"
            }`}
          >
            Home
          </Link>
          <Link
            to="/features"
            className={`transition-colors ${
              isActive("/features") ? "text-primary font-semibold" : "hover:text-primary"
            }`}
          >
            Features
          </Link>
          <Link
            to="/pricing"
            className={`transition-colors ${
              isActive("/pricing") ? "text-primary font-semibold" : "hover:text-primary"
            }`}
          >
            Pricing
          </Link>
          <Link
            to="/question-banks"
            className={`transition-colors ${
              isActive("/question-banks") ? "text-primary font-semibold" : "hover:text-primary"
            }`}
          >
            Question Banks
          </Link>
          <Link
            to="/about"
            className={`transition-colors ${
              isActive("/about") ? "text-primary font-semibold" : "hover:text-primary"
            }`}
          >
            About Us
          </Link>
        </nav>

        {/* Desktop CTA Buttons */}
        <div className="hidden md:flex items-center space-x-4">
          <Button variant="outline" onClick={() => navigate("/login")}>
            Log In
          </Button>
          <Button onClick={() => navigate("/register")}>Get Started</Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white shadow-lg"
          >
            <div className="container mx-auto py-4 flex flex-col space-y-4">
              <Link
                to="/"
                className={`py-2 transition-colors ${
                  isActive("/") ? "text-primary font-semibold" : "hover:text-primary"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/features"
                className={`py-2 transition-colors ${
                  isActive("/features") ? "text-primary font-semibold" : "hover:text-primary"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Features
              </Link>
              <Link
                to="/pricing"
                className={`py-2 transition-colors ${
                  isActive("/pricing") ? "text-primary font-semibold" : "hover:text-primary"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link
                to="/question-banks"
                className={`py-2 transition-colors ${
                  isActive("/question-banks") ? "text-primary font-semibold" : "hover:text-primary"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Question Banks
              </Link>
              <Link
                to="/about"
                className={`py-2 transition-colors ${
                  isActive("/about") ? "text-primary font-semibold" : "hover:text-primary"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <div className="flex flex-col space-y-2 pt-2 border-t">
                <Button
                  variant="outline"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/login");
                  }}
                >
                  Log In
                </Button>
                <Button
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/register");
                  }}
                >
                  Get Started
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Headers;
